import { useEffect, useState, useRef, Fragment, useMemo } from "react";
import { Button, Modal, Table, InputGroup, Popover, Overlay, Form } from "react-bootstrap";
import "./../../assets/scss/requisition/index.scss";
import {
  DownloadIcon,
  DropdownCloseIcon,
  ExcelIcon,
  Logo,
  PrintIcon,
  SignatureIcon,
} from "../Icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { backendApis, services } from "../../config";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { format } from "date-fns";
import CurrencyInput from "react-currency-input-field";
import { cloneDeep, find, isEmpty, lowerCase, uniqBy } from "lodash";
import { nanoid, waitFor } from "../../utils/helpers";
import useDebounce, { useCurrencies, useEffectOnce, useTaxOptions } from "../../utils/hooks";
import { toast } from "react-toastify";
import { cacheTimes, queryActions } from "../../utils/reactQueryActions";
import currency from "currency.js";

import ItemsTable from "../utils/ItemsTable";
import { useAuth } from "../../hooks/useAuth";
import { FieldArray, FormikProvider, useFormik } from "formik";
import RequisitionService from "../../hooks/requisitionService";
import * as yup from "yup";
import eventBus from "../../utils/EventBus";
import _ from "lodash";
import AsyncSelect from "react-select/async";
import { useStoreActions, useStoreState } from "easy-peasy";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import Select from "react-select";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import Datetime from "react-datetime";
import ConfirmDialog from "../ConfirmDialogue";
import { StaffSelectorMultiple } from "../GeneralSettingsModal";
import { read, utils } from "xlsx";

function Attachments({ files = [], setFiles }) {
  //  const [files, setFiles] = useState([]);
  const { backendUrl } = useAuth();
  return (
    <div>
      <Form.Label className="btn btn-light-blue">
        <span>Add Files </span>
        <Form.Control
          type="file"
          className="d-none"
          multiple
          onChange={e => setFiles([...files, ...e.target.files])}
        />
      </Form.Label>

      <div>
        {files?.map((el, index) => (
          <div key={index}>
            {el?.fileId ? (
              <a
                href={`${backendUrl}/api/requisition/files/${el.systemFileName}/${el.name}`}
                target="_blank"
                rel="noreferrer"
              >
                {el?.name}
              </a>
            ) : (
              <span>{el?.name}</span>
            )}

            <Button
              variant=""
              size="sm"
              onClick={e => setFiles(files.filter((el, i) => i !== index))}
            >
              <DropdownCloseIcon />
            </Button>
            <hr className="m-0" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function NewPurchaseRequisitionModal({
  location,
  requisition,
  setShowNewRequisitionModal,
  previousFormValues,
  selectedJob = {},
  handleCreatedRequisition,
  itemsRequested = [],
}) {
  const taxOptions = useTaxOptions();
  const raisedItemRequisitionData = useStoreState(store => store.raisedItemRequisitionData);
  const navigate = useNavigate();
  const locationQ = useLocation();

  const query = new URLSearchParams(locationQ.search);
  const globalValue = query.get("global");

  const initialRequestData = (requisition = {}) => {
    if (requisition.requestItems) {
      return { ...requisition.requestItems };
    }

    return {
      barcode: "",
      itemName: "",
      unitCost: "",
      quantity: "",
      invoiceNumber: "",
      Warehouse: "",
      UOM: "",
      Vendor_ID: "",
      Staff_ID_To_Advance: "",
    };
  };

  let { id } = useParams();
  const { deploymentCurrencies: currenciesOptions } = useCurrencies();
  const generalSettings = useStoreState(state => state.generalSettings);
  const { createRequisitionMutation } = RequisitionService();
  const [tableData, setTableData] = useState(itemsRequested);
  const [total, setTotal] = useState(0);
  const [purchaseRequest, setPurchaseRequest] = useState(initialRequestData(previousFormValues));

  // setPurchaseRequest
  const { user: authUser, backendUrl } = useAuth();
  const [file, setFile] = useState();
  const [reciever, setReceiver] = useState();
  const branches = useMemo(
    () =>
      // .filter((el) => el.name !== authUser.company),
      backendApis.map(el => ({
        ...el,
        label: el.name,
        value: el.name,
      })),
    [authUser]
  );

  useEffect(() => {
    let props = {
      requisition,
      setShowNewRequisitionModal,
      previousFormValues,
      selectedJob,
      handleCreatedRequisition,
      itemsRequested,
    };
    console.log(props);
  }, []);

  const handleInputChange = ({ index, name, value }) => {
    const oldTableData = tableData;

    // user must pick either vendor or staff
    if (name === "Vendor_ID") {
      oldTableData[index]["Staff_ID_To_Advance"] = "";
    } else if (name === "Staff_ID_To_Advance") {
      // one time vendor
      oldTableData[index]["Vendor_ID"] = "VND000101";
    }

    oldTableData[index][name] = value;
    setTableData([...oldTableData]);
  };

  const calculateTotal = tableData => {
    setTotal(
      tableData
        .map(el =>
          currency(el?.unitCost, {
            precision: 2,
          }).multiply(el?.quantity)
        )
        .reduce(
          (a, b) =>
            currency(a, {
              precision: 2,
            }).add(b),
          0
        )
    );
  };

  const debouncedTableData = useDebounce(tableData, 800);
  useEffect(() => {
    if (debouncedTableData) calculateTotal(debouncedTableData);
  }, [debouncedTableData]);

  const save = formValues => {
    // if (!file) toast.error("Please attach your signature");

    // ensure table has data
    if (isEmpty(tableData)) {
      return toast.error("Please add at least one item to the requisition.");
    }

    let description = "";
    description = [
      ...tableData,
      // add if form has unsaved data
      ...(purchaseRequest?.itemName
        ? [{ ...purchaseRequest, barcode: purchaseRequest?.barcode || nanoid() }]
        : []),
    ]
      .map(el => {
        delete el.subtotal;
        return Object.values(el).join(",,,");
      })
      .join("&&&");

    description = description + "&&&";

    formValues.requestto = formValues.recipient;
    formValues.regdate = format(new Date(), "yyyy-MM-dd");
    formValues.status = "Pending";

    formValues.preSelectedSignatory = JSON.stringify(formValues.preSelectedSignatory);

    const realTotal = currency(purchaseRequest?.unitCost)
      .multiply(purchaseRequest?.quantity)
      .add(total).value;

    // are the users pre-selected
    createRequisitionMutation.mutate(
      {
        requestid: id,
        description,
        file,
        amount: isNaN(realTotal) ? 0 : realTotal,
        requiredSignatoriesStaff_ID: JSON.stringify(
          generalSettings?.fundRequestMandatorySignatory || []
        ),
        ...formValues,
      },
      {
        onSuccess: data => {
          formik.resetForm();
          eventBus.dispatch("REQUISITION_CREATED", data.requisition);
          if (handleCreatedRequisition) handleCreatedRequisition();
          setShowNewRequisitionModal(false);
        },
      }
    );
  };

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [activeTableIndex, setActiveTableIndex] = useState(null);
  const ref = useRef(null);
  //  const [serviceMode, setServiceMode] = useState(false);

  const handleRowClick = (e, index) => {
    setShow(true);
    setTarget(e.target);
  };

  const createNew = e => {
    setShow(true);
    setTarget(e.target);
    setActiveTableIndex(-1);
    // setServiceMode(false);
  };

  const createNewService = async ({ activeTableIndex }) => {
    let item = {
      barcode: "SERVICE_" + nanoid(10, "number"),
      itemName: "",
      unitCost: "",
      quantity: 1,
      invoiceNumber: "",
      Warehouse: "",
      type: "SERVICE",
      UOM: "",
      Staff_ID_To_Advance: "",
    };

    let oldTableData = tableData;

    if (activeTableIndex === -1) {
      oldTableData = [...oldTableData, item];
    } else {
      oldTableData[activeTableIndex] = item;
    }
    setTableData([...oldTableData]);
    if (activeTableIndex === -1) setActiveTableIndex(oldTableData.length - 1);
    setShow(false);
  };

  const handleSelectedItem = item => {
    if (!item.Warehouse) {
      return toast.error("Only warehouse items can be selected");
    }

    if (item.Warehouse) {
      if (isEmpty(item.accountName)) {
        return toast.error("Please map this item to an Account");
      }
    }

    item = {
      barcode: item.Bar_Code,
      itemName: item.Item_Name,
      unitCost: item.UnitCost,
      quantity: 1,
      invoiceNumber: "",
      Warehouse: item.Warehouse,
      UOM: item?.Product_Model || "Each",
      Vendor_ID: "",
      Staff_ID_To_Advance: "",
    };

    let oldTableData = tableData;

    if (activeTableIndex === -1) {
      oldTableData = [...oldTableData, item];
    } else {
      oldTableData[activeTableIndex] = item;
    }
    setTableData([...oldTableData]);
    if (activeTableIndex === -1) setActiveTableIndex(oldTableData.length - 1);
    setShow(false);
  };

  const removeSelection = () => {
    const oldTableData = tableData.filter((el, index) => index !== activeTableIndex);
    setTableData([...oldTableData]);
  };

  const handlePurchaseRequestInput = (value, name) => {
    setPurchaseRequest({
      ...purchaseRequest,
      [name]: value,
    });
  };

  const createNewPurchaseRequest = e => {
    if (!e.target.value) return;
    if (lowerCase(requisition?.type) === "material request") {
      if (isEmpty(purchaseRequest.barcode)) {
        purchaseRequest.barcode = nanoid();
      }
    }
    setTableData([...tableData, purchaseRequest]);
    e.target.blur();

    setTimeout(() => {
      // console.log(initialRequestData(previousFormValues), previousFormValues);
      setPurchaseRequest(() => ({ ...initialRequestData(previousFormValues) }));
    }, 10);
  };

  const addNewPurchaseRequest = () => {
    if (lowerCase(requisition?.type) === "material request") {
      if (isEmpty(purchaseRequest.barcode)) {
        purchaseRequest.barcode = nanoid();
      }
    }

    setTableData([...tableData, purchaseRequest]);
    setTimeout(() => {
      setPurchaseRequest(() => ({ ...initialRequestData(previousFormValues) }));
    }, 5);
  };

  const formik = useFormik({
    initialValues: {
      title: previousFormValues.title,
      type: previousFormValues.type,
      department: previousFormValues.department,
      recipient: previousFormValues.recipient,
      jobGrade: previousFormValues.jobGrade,
      comment: previousFormValues.comment,
      vendor: previousFormValues.vendor,
      jobNumber: previousFormValues.jobNumber,
      paymentType: "",
      currency: generalSettings?.prevailingCurrency,
      conversionAmount: generalSettings.dollarInBaseCurrency,
      expectedDeliveryDate: new Date(),
      projectDescription: "",
      initialFiles: [],
      branch: branches.find(el => authUser?.company === el.name)?.name,
      requesterAccountName: "",
      requesterAccountNumber: "",
      requesterBank: "",
      attachedRequestid: previousFormValues.attachedRequestid,
      preSelectedSignatory: previousFormValues?.preSelectedSignatory || [],
      attachedTransactionID: previousFormValues?.attachedTransactionID || "",
      invoiceNumber: "",
      vendorTaxes: [
        {
          Vendor_ID: "",
          tax: "",
          taxType: "",
          invoiceNumber: "",
          taxTypePercentage: 0,
        },
      ],
    },
    validationSchema: yup.object().shape({
      title: yup.string().required(),
      type: yup.string().required(),
      // department: yup.string().required(),
      // recipient: yup.string().required(),
      comment: yup.string(),
      //  vendor: yup.string().required(),
    }),
    onSubmit: async values => {
      const foundInvoiceNumber = tableData.find(el => el.invoiceNumber);
      const emptyInvoiceNumber = tableData.find(el => !el.invoiceNumber);

      // Deprecated
      /*  if (foundInvoiceNumber && emptyInvoiceNumber) {
        return toast.error("All items must have an invoice number if one is provided.");
      } */

      values = cloneDeep(values);

      if (isEmpty(values.comment)) values.comment = "...";
      if (
        isEmpty(values.recipient) &&
        !(await ConfirmDialog({
          title: "Recipient not Selected",
          description: "Continue?",
        }))
      ) {
        return;
      }

      values.vendorTaxes = JSON.stringify(
        values.vendorTaxes.map(el => ({ ...el, taxType: el.taxType || "" }))
      );
      save(values);
    },
  });

  const getUsersInDepartments = async department => {
    let response = await fetch(`${backendUrl}/api/users/by-department/${department}`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    // ===========
    const { data } = await response.json();

    data.users = [
      { label: "Select Recipient", value: "" },
      ...data.users
        .map(el => ({
          ...el,
          label: `${el?.changeableId ? el?.changeableId : el.Staff_ID} - ${el.Name}`,
          value: el.Staff_ID,
        }))
        .filter(el => el.Staff_ID !== authUser.Staff_ID),
    ];

    return data;
  };

  const {
    data: { users } = { users: [] },
    refetch: getUsers,
    isFetching: isLoadingUsers,
  } = useQuery(
    [queryActions.GET_USERS_IN_DEPARTMENTS, formik.values.department],
    () => getUsersInDepartments(formik.values.department),
    {
      enabled: false,
    }
  );

  const fetchVendors = async () => {
    let response = await fetch(`${backendUrl}/api/vendors`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    data.vendors = [
      { label: "None", value: "" },
      ...data.vendors.map(el => ({
        ...el,
        label: `  ${el.CompanyName} / ${el.Vendor_ID}`,
        value: `  ${el.CompanyName} / ${el.Vendor_ID}`,
      })),
    ];
    return data;
  };
  const { data: { vendors = [] } = { vendors: [] }, isFetching: isLoadingVendors } = useQuery(
    [queryActions.GET_VENDORS],
    () => fetchVendors(),
    {
      enabled: true,
    }
  );

  const fetchJobs = async (inputValue, callback) => {
    let response = await fetch(`${backendUrl}/api/job?page=1&Limit=50&Title=${inputValue}`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    if (data.jobs)
      callback(
        (data.jobs = data.jobs.map(el => ({
          ...el,
          label: el.title,
          value: el.jobNumber,
        })))
      );
  };

  const debouncedFetchJobs = _.debounce(fetchJobs, 500);

  const loadOptions = (inputValue, callback) => {
    debouncedFetchJobs(inputValue, callback);
  };

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(el => el.cc === formik.values.currency);
    return foundCurrency ? foundCurrency.symbol : "";
  }, [formik.values.currency]);

  //-------------------------------------------------------------------------------------
  // fetch data for form
  const getDepartments = async ({ branch }) => {
    let response = await fetch(
      `${branches.find(el => branch === el.name)?.url}/api/users/departments-with-users`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    // HOT ADDITION -
    data.warehouses = data.warehouses?.map(el => ({
      ...el,
      value: el.W_ID,
      label: el.W_name,
    }));

    return data;
  };

  const {
    data = {
      departments: [],
      staffs: [],
      jobGrades: [],
      departmentWithLeads: [],
      warehouses: [],
    },
    isFetching: isFetchingStaffs,
  } = useQuery(
    [queryActions.GET_USERS_WITH_DEPARTMENTS, formik.values.branch],
    () =>
      getDepartments({
        branch: formik.values.branch,
      }),
    {
      enabled: true,
      keepPreviousData: true,
      cacheTime: cacheTimes.GET_USERS_WITH_DEPARTMENTS,
    }
  );

  const allStaffs = useMemo(() => {
    return data.staffs.map(el => ({
      ...el,
      label: `${el?.changeableId ? el?.changeableId : el.Staff_ID} - ${el.Name}`,
      value: el.Staff_ID,
    }));
  }, [data.staffs]);

  const staffSelectOptions = useMemo(() => {
    const jobGrades = data.staffs
      .filter(el => el.Department === formik.values.department)
      .map(el => ({ jobGrade: el.jobGrade }));

    const staffs = data.staffs.filter(el => {
      if (!formik.values.department) return true;
      if (!formik.values.department && !formik.values.jobGrade) return true;
      if (formik.values.department === "Department Lead") {
        const myDepartmentLead = data.departmentWithLeads
          .filter(el => el.Dept_Lead && el.Dept_Name === authUser.Department)
          .map(el => JSON.parse(el.Dept_Lead))
          .flat();

        return myDepartmentLead.find(lead => lead.Staff_ID === el.Staff_ID);
      }
      if (formik.values.department && !formik.values.jobGrade) {
        return el.Department === formik.values.department;
      }
      if (formik.values.department && formik.values.jobGrade) {
        return el.Department === formik.values.department && el.jobGrade === formik.values.jobGrade;
      }
    });

    return {
      departments: [
        { label: "Any Department", value: "" },
        { label: "Department Lead", value: "Department Lead" },
        ...data.departments.map(el => ({
          label: el.Department,
          value: el.Department,
        })),
      ],
      jobGrades: [
        { label: "Any Job Grade", value: "" },
        ...uniqBy(jobGrades, "jobGrade").map(el => ({
          label: el.jobGrade,
          value: el.jobGrade,
        })),
      ],
      staffs: [
        { label: "Any Staff", value: "" },
        ...staffs.map(el => ({
          label: `${el?.changeableId ? el?.changeableId : el.Staff_ID} - ${el.Name}`,
          value: el.Staff_ID,
        })),
      ],
    };
  }, [data, formik.values.department, formik.values.jobGrade, formik.values.branch]);

  // GET FORM PERMISION
  const getNumberSystems = async () => {
    let response = await fetch(`${backendUrl}/api/numbersystem`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    await waitFor(100);

    if (!isEmpty(formik.values.preSelectedSignatory)) {
      const permissions = formik.values.preSelectedSignatory;

      if (permissions) {
        setReceiver(permissions[1]);
        formik.setFieldValue("department", permissions[1].department);
        formik.setFieldValue("recipient", permissions[1].staff);
        formik.setFieldValue("jobGrade", permissions[1].jobGrade);
      }
    } else if (data?.numberSystems) {
      const permissions = JSON.parse(
        data.numberSystems.find(
          el => el?.documentType === formik.values?.type && Boolean(el.enablePreSelectSignatory)
        )?.selectedSignatory || "[]"
      );

      if (!isEmpty(permissions)) {
        setReceiver(permissions[1]);
        formik.setFieldValue("department", permissions[1].department);
        formik.setFieldValue("recipient", permissions[1].staff);
        formik.setFieldValue("jobGrade", permissions[1].jobGrade);
      }
    }

    return data;
  };

  const { refetch: refetchPermissions } = useQuery(["NUMBER_SYSTEMS"], () => getNumberSystems(), {
    keepPreviousData: true,
  });
  // ---

  function handleFile({ eventData: e, type }) {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async function(e) {
        const workbook = read(e.target.result, {
          cellDates: true,
          dateNF: "yyyy-MM-dd HH:mm:ss.SSS",
        });
        let rows = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
          defval: "",
          dateNF: "yyyy-MM-dd HH:mm:ss.SSS",
        });

        if (
          !(await ConfirmDialog({
            title: "Are you sure?",
            description: "You want to import",
          }))
        ) {
          return;
        }

        let schema = yup.object().shape({
          items: yup.array().of(
            yup.object({
              description: yup.string().required(),
              unitCost: yup.string().required(),
              quantity: yup.string().default("0"),
            })
          ),
        });
        try {
          await schema.validate({ items: rows });

          // Clean Up
          rows = rows.map(el => ({
            ...el,
          }));
          setTableData(rows);
        } catch (err) {
          console.log(err);
          toast.error(err.name);
          toast.error(JSON.stringify(err.errors));
        }
      };
      reader.readAsArrayBuffer(file);
    }
    e.target.value = "";
  }

  useEffect(() => {
    if (globalValue) {
      setTableData(prev => [
        {
          barcode: raisedItemRequisitionData?.Bar_Code,
          itemName: raisedItemRequisitionData?.Item_Name,
          unitCost: raisedItemRequisitionData?.UnitCost,
          quantity: raisedItemRequisitionData?.Quantity,
          Warehouse: raisedItemRequisitionData?.Warehouse,
          UOM: raisedItemRequisitionData?.Product_Model || "Each",
          Staff_ID_To_Advance: raisedItemRequisitionData?.Staff_ID_To_Advance || "",
        },
      ]);

      const branch = raisedItemRequisitionData?.branch;
      formik.setFieldValue("branch", branch?.name);

      setPurchaseRequest(prev => [
        {
          ...prev,
          barcode: raisedItemRequisitionData?.Bar_Code,
          itemName: raisedItemRequisitionData?.Item_Name,
          unitCost: raisedItemRequisitionData?.UnitCost,
          Warehouse: raisedItemRequisitionData?.Warehouse,
          UOM: raisedItemRequisitionData?.Product_Model || "Each",
          Staff_ID_To_Advance: raisedItemRequisitionData?.Staff_ID_To_Advance || "",
        },
      ]);

      /*!SECTION

{
    description: string;
    unitCost: string;
    quantity: string;
    barcode?: undefined;
    itemName?: undefined;
    quantityRequested?: undefined;
    availability?: undefined;
    quantityApproved?: undefined;
}

      */

      query.delete("global");
      navigate(`${locationQ.pathname}?${query.toString()}`, { replace: true });
    }
  }, [globalValue, raisedItemRequisitionData]);

  // ==============================================================

  const tableDataWithVendor = useMemo(() => {
    if (!vendors) return [];

    // Create a Map for O(1) lookups
    const vendorMap = new Map(vendors.map(v => [v.Vendor_ID, v]));
    const staffMap = new Map(allStaffs.map(s => [s.Staff_ID, s]));

    const records = cloneDeep(tableData).map(el => {
      const Vendor_ID =
        el.Vendor_ID && el.Vendor_ID !== " " ? el.Vendor_ID : formik.values.Vendor_ID;
      const invoiceNumber =
        el.invoiceNumber && el.invoiceNumber !== " "
          ? el.invoiceNumber
          : formik.values.invoiceNumber;

      const vendor = vendorMap.get(Vendor_ID);
      const vendorName = vendor?.label || Vendor_ID;

      return {
        ...el,
        invoiceNumber,
        Vendor_ID: Vendor_ID || "",
        vendorName,
        vendor: vendorName,
        Vendor: Vendor_ID || "",
        uniqueInvoiceAndVendor: `${invoiceNumber}-${Vendor_ID}-${el.Staff_ID_To_Advance}`,
        staffName: staffMap.get(el.Staff_ID_To_Advance)?.label || el.Staff_ID_To_Advance,
      };
    });

    return records;
  }, [tableData, formik.values.invoiceNumber, formik.values.Vendor_ID, vendors]);

  const invoiceNumbersInTable = useMemo(
    () => uniqBy([...tableDataWithVendor], "uniqueInvoiceAndVendor"),
    [tableDataWithVendor]
  );

  const findVendor = Vendor_ID => {
    if (!Vendor_ID) return null;
    if (!vendors) return Vendor_ID;

    const vendor = vendors.find(el => el.Vendor_ID === Vendor_ID);
    if (vendor) {
      return vendor?.label;
    } else {
      return Vendor_ID;
    }
  };

  const findStaff = Staff_ID => {
    if (!Staff_ID) return null;
    if (!allStaffs) return Staff_ID;

    const staff = allStaffs.find(el => el.Staff_ID === Staff_ID);
    if (staff) {
      return staff?.label;
    } else {
      return Staff_ID;
    }
  };

  const calculateTax = ({ taxTypeSelected = "", invoiceAmount = 0 }) => {
    if (!taxTypeSelected) return 0;
    const taxType = taxOptions.find(el => el.value === taxTypeSelected);
    return currency(invoiceAmount).multiply(taxType?.percentage).value;
  };

  const calculateVendorSubTotal = ({ invoiceNumber, Vendor_ID }) => {
    // if (!invoiceNumber || !Vendor_ID) return 0;

    const total = tableDataWithVendor
      .filter(item => item.invoiceNumber === invoiceNumber && item.Vendor_ID === Vendor_ID)
      .map(el => currency(el.unitCost).multiply(el.quantity).value)
      .reduce((a, b) => currency(a).add(b).value, 0);

    return total;
  };

  const handleSelectedTaxType = ({
    taxType,
    invoiceNumber,
    Vendor_ID,
    percentage: taxTypePercentage,
    ...otherValues
  }) => {
    let updatedVendorTaxes = [...formik.values.vendorTaxes];
    const foundIndex = updatedVendorTaxes.findIndex(tax => tax.Vendor_ID === Vendor_ID);

    if (foundIndex !== -1) {
      // Update existing ==============
      updatedVendorTaxes[foundIndex] = {
        ...updatedVendorTaxes[foundIndex],
        taxType,
        taxTypePercentage,
        invoiceNumber,
        Vendor_ID,
      };
    } else {
      // Add new =======================
      updatedVendorTaxes.push({
        Vendor_ID,
        invoiceNumber,
        taxType,
        taxTypePercentage,
        ...otherValues,
      });
    }
    formik.setFieldValue("vendorTaxes", updatedVendorTaxes);
  };
  // ===============================================================

  return (
    <div>
      <Modal
        show={true}
        onHide={() => setShowNewRequisitionModal(false)}
        dialogClassName="requisition-details-modal preview-modal create-form"
        backdropClassName={`global-backdrop`}
        centered={true}
        animation={false}
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h1 className="py-2 capitalize">{previousFormValues.type}</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="preview p-0">
          <div className="preview-content p-0">
            <div className="content">
              <div className="preview-body">
                <FormikProvider value={formik}>
                  <Form
                    className="mb-3"
                    id="requisition-form"
                    noValidate
                    onSubmit={formik.handleSubmit}
                  >
                    <Form.Group className="mb-3">
                      <Form.Label>Title :</Form.Label>
                      <Form.Control
                        name="title"
                        placeholder="Enter a title"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        isInvalid={formik.touched.title && !!formik.errors.title}
                      />

                      <Form.Control.Feedback type="invalid">
                        {formik.errors.title}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <div className="row gap-3">
                      <Form.Group className="col mb-3">
                        <Form.Label>Vendor (Optional) :</Form.Label>
                        <Select
                          classNamePrefix={"form-select"}
                          name="vendor"
                          options={vendors}
                          value={vendors.find(el => el.value === formik.values.vendor)}
                          onChange={selected => {
                            formik.setFieldValue("vendor", selected?.value);
                            formik.setFieldValue("Vendor_ID", selected?.Vendor_ID);
                          }}
                          isDisabled={
                            lowerCase(previousFormValues.type) === "retirement for purchase request"
                          }
                          isLoading={isLoadingVendors}
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.vendor}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="col mb-3">
                        <Form.Label>Job / Contract :</Form.Label>

                        <AsyncSelect
                          classNamePrefix={"form-select"}
                          className="customer-select-dropdown"
                          menuPlacement="bottom"
                          menuPosition="fixed"
                          isSearchable={true}
                          isClearable={true}
                          defaultOptions
                          onChange={selection => {
                            formik.setFieldValue("jobNumber", selection?.value);
                          }}
                          loadOptions={loadOptions}
                          defaultValue={!isEmpty(selectedJob) ? selectedJob : {}}
                        />
                      </Form.Group>
                    </div>

                    <Form.Group className="my-3">
                      <Form.Label>Comment :</Form.Label>
                      <label className="border p-0 rounded message-area d-block">
                        <Form.Control
                          name="comment"
                          value={formik.values.comment}
                          onChange={formik.handleChange}
                          as="textarea"
                          className="w-100 border-0 p-3"
                          placeholder="Enter a comment"
                          rows={4}
                        />
                      </label>
                    </Form.Group>

                    <p className="fw-5">Send To</p>
                    <div className="row gap-3">
                      <Form.Group className="col mb-3">
                        <Form.Label>Department :</Form.Label>
                        <Select
                          classNamePrefix={`form-select`}
                          name="department"
                          options={staffSelectOptions?.departments}
                          value={staffSelectOptions?.departments.find(
                            el => el.value === formik.values.department
                          )}
                          onChange={({ value }) => {
                            formik.setFieldValue("department", value);

                            // clear others
                            formik.setFieldValue("jobGrade", "");
                            formik.setFieldValue("recipient", "");
                          }}
                          isDisabled={reciever?.department}
                          isLoading={isFetchingStaffs}
                        />
                      </Form.Group>

                      <Form.Group className="col mb-3">
                        <Form.Label>Job Grade :</Form.Label>
                        <Select
                          classNamePrefix={`form-select`}
                          name="jobGrade"
                          options={staffSelectOptions?.jobGrades}
                          value={staffSelectOptions?.jobGrades.find(
                            el => el.value === formik.values.jobGrade
                          )}
                          onChange={({ value }) => {
                            formik.setFieldValue("jobGrade", value);

                            // clear others
                            formik.setFieldValue("recipient", "");
                          }}
                          isDisabled={
                            reciever?.jobGrade ||
                            reciever?.staff ||
                            reciever?.department === "Department Lead"
                          }
                          isLoading={isFetchingStaffs}
                        />
                      </Form.Group>

                      <Form.Group className="col mb-3">
                        <Form.Label>Recipient :</Form.Label>
                        <Select
                          classNamePrefix={`form-select`}
                          name="recipient"
                          options={staffSelectOptions?.staffs}
                          value={staffSelectOptions?.staffs.find(
                            el => el.value === formik.values.recipient
                          )}
                          onChange={({ value }) => {
                            if (value === authUser.Staff_ID) {
                              toast.warning(
                                "Invalid action: You cannot send a request to yourself."
                              );
                            } else {
                              formik.setFieldValue("recipient", value);
                            }
                          }}
                          isDisabled={reciever?.staff}
                          isLoading={isFetchingStaffs}
                        />
                      </Form.Group>
                    </div>
                  </Form>
                </FormikProvider>

                <Attachments
                  files={formik.values.initialFiles}
                  setFiles={files => formik.setFieldValue("initialFiles", files)}
                />
                <div className="my-2" />

                <Table responsive borderless striped className="product-table">
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>Item Name</th>
                      <th>Item Code</th>
                      <th>Unit Cost</th>
                      <th>Quantity</th>
                      <th>UOM</th>
                      <th>Subtotal</th>
                      <th>Warehouse</th>
                      <th>Invoice Number / Ref</th>
                      <th>Vendor</th>
                      <th>{/* Advance to Staff */}</th>
                    </tr>
                  </thead>
                  <tbody ref={ref}>
                    {tableData &&
                      tableData.map((el, index) => (
                        <tr
                          key={el.barcode}
                          className={`${activeTableIndex === index && "active-row"}`}
                          onClick={() => activeTableIndex !== index && setActiveTableIndex(index)}
                        >
                          <td>{index + 1}</td>

                          {el.type === "SERVICE" ? null : (
                            <td className="p-cursor" onClick={e => handleRowClick(e, index)}>
                              {el.barcode}
                            </td>
                          )}

                          <td colSpan={el.type === "SERVICE" ? 2 : 1}>
                            {el.type === "SERVICE" ? (
                              <textarea
                                className="form-control border-1 px-1 bg-white"
                                style={{ width: 300 }}
                                value={el.itemName}
                                onKeyDown={e => e.keyCode === 13 && e.target.blur()}
                                onChange={e =>
                                  handleInputChange({
                                    index,
                                    name: "itemName",
                                    value: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              el.itemName
                            )}
                          </td>
                          <td>
                            <div style={{ width: "120px" }}>
                              <CurrencyInput
                                className="form-control border-0 px-1"
                                value={el.unitCost}
                                onKeyDown={e => e.keyCode === 13 && e.target.blur()}
                                name="unitCost"
                                onValueChange={(value, name) =>
                                  handleInputChange({
                                    index,
                                    name,
                                    value,
                                  })
                                }
                                decimalsLimit={2}
                              />
                            </div>
                          </td>
                          <td>
                            <CurrencyInput
                              className="form-control border-0 px-1"
                              value={el.quantity}
                              onKeyDown={e => e.keyCode === 13 && e.target.blur()}
                              name="quantity"
                              onValueChange={(value, name) =>
                                handleInputChange({
                                  index,
                                  name,
                                  value,
                                })
                              }
                              allowNegativeValue={false}
                              allowDecimals={true}
                            />
                          </td>
                          <td>{el?.UOM || ""}</td>
                          <td>
                            <div style={{ width: "120px" }}>
                              <CurrencyInput
                                className="form-control border-0 px-1"
                                name="subtotal"
                                disabled
                                value={
                                  !isNaN(el.unitCost * el.quantity)
                                    ? currency(el.unitCost, {
                                        precision: 2,
                                      }).multiply(el.quantity)
                                    : 0
                                }
                                onKeyDown={e => e.keyCode === 13 && e.target.blur()}
                                onValueChange={(value, name) =>
                                  handleInputChange({
                                    index,
                                    name,
                                    value,
                                  })
                                }
                                decimalsLimit={2}
                              />
                            </div>
                          </td>

                          <td>
                            {el.type === "SERVICE" ? (
                              ""
                            ) : (
                              <div style={{ width: "150px" }}>
                                <Select
                                  name={`Warehouse`}
                                  options={data.warehouses}
                                  value={
                                    data.warehouses.find(w => w.value === el.Warehouse) || null
                                  }
                                  onChange={selected =>
                                    handleInputChange({
                                      index,
                                      name: "Warehouse",
                                      value: selected?.value,
                                    })
                                  }
                                  placeholder="Select warehouse"
                                  isClearable
                                  isDisabled
                                />
                              </div>
                            )}
                          </td>

                          <td>
                            <input
                              className="form-control border-1 px-1 bg-white"
                              value={el.invoiceNumber}
                              // key={el.invoiceNumber}
                              onKeyDown={e => e.keyCode === 13 && e.target.blur()}
                              onChange={e =>
                                handleInputChange({
                                  index,
                                  name: "invoiceNumber",
                                  value: e.target.value,
                                })
                              }
                            />
                          </td>

                          <td>
                            <div style={{ width: "150px" }}>
                              <Select
                                name="vendor"
                                key={el.Vendor_ID}
                                options={vendors}
                                value={vendors.find(vendor => vendor.Vendor_ID === el.Vendor_ID)}
                                onChange={selected =>
                                  handleInputChange({
                                    index,
                                    name: "Vendor_ID",
                                    value: selected?.Vendor_ID,
                                  })
                                }
                                menuPosition="fixed"
                              />
                            </div>
                          </td>

                          <td>
                            {/* <div style={{ width: "150px" }}>
                              <Select
                                name="Staff_ID_To_Advance"
                                key={el.Staff_ID_To_Advance}
                                options={allStaffs}
                                value={allStaffs.find(
                                  staff => staff.value === el.Staff_ID_To_Advance
                                )}
                                onChange={selected => {
                                  handleInputChange({
                                    index,
                                    name: "Staff_ID_To_Advance",
                                    value: selected?.value,
                                  });
                                }}
                                menuPosition="fixed"
                              />
                            </div> */}
                          </td>
                        </tr>
                      ))}

                    <tr
                      className={`bg-light p-cursor ${activeTableIndex === -1 && "active-row"}`}
                      onClick={() => activeTableIndex !== -1 && setActiveTableIndex(-1)}
                      key={activeTableIndex}
                    >
                      <td colSpan={11}>
                        <Button
                          onClick={e => createNew(e)}
                          outline=""
                          type="button"
                          variant="outline-primary"
                          size="sm"
                          className="text-nowrap"
                        >
                          + Add Item
                        </Button>

                        <span className="mx-2" />

                        <Button
                          onClick={_ =>
                            createNewService({
                              activeTableIndex: -1,
                            })
                          }
                          outline=""
                          type="button"
                          variant="outline-primary"
                          size="sm"
                          className="text-nowrap"
                        >
                          + Add Service
                        </Button>
                      </td>
                      {/*  <td>
                        <input
                          className="form-control border-1 px-1 bg-white"
                          name="barcode"
                          value={purchaseRequest.barcode}
                          onKeyDown={e => e.keyCode === 13 && createNewPurchaseRequest(e)}
                          onChange={e => handlePurchaseRequestInput(e.target.value, e.target.name)}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control border-1 px-1 bg-white"
                          name="itemName"
                          value={purchaseRequest.itemName}
                          onKeyDown={e => e.keyCode === 13 && createNewPurchaseRequest(e)}
                          onChange={e => handlePurchaseRequestInput(e.target.value, e.target.name)}
                        />
                      </td>
                      <td>
                        <CurrencyInput
                          className="form-control border-1 px-1 bg-white"
                          value={purchaseRequest.quantity}
                          onKeyDown={e => e.keyCode === 13 && e.target.blur()}
                          name="quantity"
                          onValueChange={(value, name) => handlePurchaseRequestInput(value, name)}
                          allowNegativeValue={false}
                          allowDecimals={true}
                        />
                      </td>
                      <td>
                        <CurrencyInput
                          className="form-control border-1 px-1 bg-white"
                          value={purchaseRequest.unitCost}
                          onKeyDown={e => e.keyCode === 13 && e.target.blur()}
                          name="unitCost"
                          onValueChange={(value, name) => handlePurchaseRequestInput(value, name)}
                          allowNegativeValue={false}
                          allowDecimals={true}
                        />
                      </td>
                      <td>
                        {purchaseRequest.unitCost && purchaseRequest.quantity ? (
                          <CurrencyInput
                            className="form-control border-0 px-0 bg-white"
                            name="subtotal"
                            disabled
                            value={
                              !isNaN(purchaseRequest.unitCost * purchaseRequest.quantity)
                                ? currency(purchaseRequest.unitCost, {
                                    precision: 2,
                                  }).multiply(purchaseRequest.quantity)
                                : ""
                            }
                            decimalsLimit={2}
                          />
                        ) : null}{" "}
                      </td> */}
                    </tr>

                    <tr className="">
                      <td colSpan={11} className="p-0 px-2">
                        <div className="row g-3 bg-white">
                          {invoiceNumbersInTable.map((el, index) => (
                            <div
                              key={index}
                              className="col-3 p-3 fw-4 border rounded position-relative"
                              style={{ fontWeight: 400 }}
                            >
                              <p title={el?.invoiceNumber}>
                                <b> Invoice Number / Ref:</b>{" "}
                                {el?.invoiceNumber ? (
                                  <span>{el.invoiceNumber}</span>
                                ) : (
                                  <span className="text-danger">No Invoice Number Entered</span>
                                )}
                              </p>
                              <p title={el.Vendor_ID}>
                                <b>Vendor:</b>{" "}
                                {el.Vendor_ID ? (
                                  <span>{findVendor(el.Vendor_ID)}</span>
                                ) : (
                                  <span className="text-danger">No Vendor Selected</span>
                                )}
                              </p>

                              {/* <p>
                                <b>Staff To Advance:</b>{" "}
                                {el?.Staff_ID_To_Advance ? (
                                  <span>{findStaff(el.Staff_ID_To_Advance)}</span>
                                ) : (
                                  <span className="text-danger">No Staff Selected</span>
                                )}
                              </p> */}

                              <p>
                                <b>Total Amount:</b>{" "}
                                {currency(
                                  calculateVendorSubTotal({
                                    invoiceNumber: el.invoiceNumber,
                                    Vendor_ID: el.Vendor_ID,
                                  }),
                                  {
                                    symbol: currencySymbol,
                                  }
                                ).format()}
                              </p>

                              <Form.Group className="col-md-12 my-3">
                                <p className="mb-1">
                                  <b> Tax:</b>
                                </p>

                                <div className="w-100">
                                  <Select
                                    classNamePrefix="form-select"
                                    placeholder="Select Tax"
                                    isSearchable={false}
                                    value={taxOptions.find(
                                      el =>
                                        el?.value ===
                                        formik.values.vendorTaxes?.find(
                                          vendorTax =>
                                            vendorTax.Vendor_ID === el.Vendor_ID &&
                                            vendorTax.invoiceNumber === el.invoiceNumber
                                        )?.taxType
                                    )}
                                    options={taxOptions}
                                    onChange={selected =>
                                      handleSelectedTaxType({
                                        ...selected,
                                        taxType: selected?.value,
                                        percentage: selected?.percentage,
                                        Vendor_ID: el.Vendor_ID,
                                        invoiceNumber: el.invoiceNumber,
                                      })
                                    }
                                    isClearable
                                    menuPosition="fixed"
                                  />
                                </div>
                              </Form.Group>

                              <Form.Group className="col-md-12 my-3">
                                <p className="mb-1">
                                  <b>
                                    {" "}
                                    <span>
                                      {
                                        formik.values.vendorTaxes?.find(
                                          vendorTax =>
                                            vendorTax.Vendor_ID === el?.Vendor_ID &&
                                            vendorTax.invoiceNumber === el?.invoiceNumber
                                        )?.taxType
                                      }{" "}
                                      &nbsp;
                                    </span>
                                  </b>
                                </p>

                                <div className="w-100">
                                  <CurrencyCustomInput
                                    name="tax"
                                    value={calculateTax({
                                      taxTypeSelected: formik.values.vendorTaxes?.find(
                                        vendorTax =>
                                          vendorTax.Vendor_ID === el.Vendor_ID &&
                                          vendorTax.invoiceNumber === el.invoiceNumber
                                      )?.taxType,
                                      invoiceAmount: calculateVendorSubTotal({
                                        invoiceNumber: el.invoiceNumber,
                                        Vendor_ID: el.Vendor_ID,
                                      }),
                                    })}
                                    onValueChange={(value, name) => {}}
                                    placeholder="0.00"
                                  />
                                </div>
                              </Form.Group>

                              <p>
                                <b>Total Invoice Amount:</b>{" "}
                                {currency(
                                  calculateVendorSubTotal({
                                    invoiceNumber: el.invoiceNumber,
                                    Vendor_ID: el.Vendor_ID,
                                  }) +
                                    calculateTax({
                                      taxTypeSelected: formik.values.vendorTaxes?.find(
                                        vendorTax =>
                                          vendorTax.Vendor_ID === el.Vendor_ID &&
                                          vendorTax.invoiceNumber === el.invoiceNumber
                                      )?.taxType,
                                      invoiceAmount: calculateVendorSubTotal({
                                        invoiceNumber: el.invoiceNumber,
                                        Vendor_ID: el.Vendor_ID,
                                      }),
                                    }),
                                  {
                                    symbol: currencySymbol,
                                  }
                                ).format()}
                              </p>
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Overlay
                  show={show}
                  onHide={() => setShow(false)}
                  target={target}
                  container={document.body}
                  containerPadding={0}
                  rootClose={true}
                  popperConfig={{
                    strategy: "fixed",
                    modifiers: [
                      {
                        name: "ga-custom",
                        enabled: true,
                        phase: "beforeWrite",
                        fn({ state }) {
                          const oldTransfrom = String(state.styles.popper?.transform);
                          const y = Number(
                            String(oldTransfrom)
                              .split(",")[1]
                              .split(")")[0]
                              .split("px")[0]
                              .trim()
                          );

                          const x = Number(
                            String(oldTransfrom)
                              .split(",")[0]
                              .split("(")[1]
                              .split("px")[0]
                              .trim()
                          );

                          // console.log(x, y, y < -210);
                          // state.styles.popper.left = `50%`;
                          // state.styles.popper.top = `50%`;

                          state.styles.popper.transform =
                            y < -210 ? `translate(${x}px, ${-210}px)` : `translate(${x}px, ${y}px)`;
                        },
                      },
                    ],
                  }}
                >
                  <Popover
                    style={{
                      maxWidth: "unset",
                      height: "28.75rem",
                      overflow: "hidden",
                      boxShadow: "0px 4px 20px 0px #131B2814",
                    }}
                  >
                    <ItemsTable
                      handleSelectedItem={handleSelectedItem}
                      type={
                        lowerCase(previousFormValues.type) !== "inventory"
                          ? previousFormValues.type
                          : ""
                      }
                      getItemFrom={
                        lowerCase(previousFormValues.type) !== "inventory" ? "Equipment" : "Items"
                      }
                    />
                  </Popover>
                </Overlay>
              </div>

              <div className="preview-footer  mt-2">
                <>
                  <p>Total Amount: </p>
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">{currencySymbol}</InputGroup.Text>
                    <CurrencyInput
                      placeholder="0.00"
                      className="form-control"
                      disabled
                      value={total}
                    />
                  </InputGroup>
                </>
              </div>

              <div className="p-3 my-4 border">
                <p>If Approved, funds should be paid to</p>
                <Table borderless responsive className="upsert-table">
                  <tbody>
                    <tr>
                      <td className="fw-bold  text-right">Account Name:</td>
                      <td>
                        <Form.Control
                          placeholder="Enter Account Name"
                          name="requesterAccountName"
                          value={formik.values.requesterAccountName}
                          onChange={formik.handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold  text-right">Account Number:</td>
                      <td>
                        <Form.Control
                          placeholder="Enter Account Number"
                          name="requesterAccountNumber"
                          value={formik.values.requesterAccountNumber}
                          onChange={formik.handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold  text-right">Bank:</td>
                      <td>
                        <Form.Control
                          placeholder="Enter Bank"
                          name="requesterBank"
                          value={formik.values.requesterBank}
                          onChange={formik.handleChange}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td className="fw-bold text-right">Invoice Number:</td>
                      <td>
                        <Form.Control
                          placeholder="Enter Invoice Number"
                          name="invoiceNumber"
                          value={formik.values.invoiceNumber}
                          onChange={formik.handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="px-4 bg-white">
          {![null, -1].includes(activeTableIndex) ? (
            <Button
              disabled={createRequisitionMutation.isLoading}
              onClick={() => removeSelection()}
              variant="danger"
              size="sm"
              className="text-white px-3 "
            >
              Remove Selection
            </Button>
          ) : (
            <span />
          )}

          <div className="proceed-actions">
            <Button
              disabled={createRequisitionMutation.isLoading}
              //  onClick={() => save()}
              variant="primary"
              size="sm"
              type="submit"
              form="requisition-form"
            >
              {createRequisitionMutation.isLoading ? "Please wait..." : "Send request"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
